export const mediaQueriesMixin = {
    methods: {
        isMobile() {
            return this.$mq === 'mobileSmall' || this.$mq === 'mobile';
        },
        isMobileDevice() {
            return ['mobileSmall', 'mobile', 'tablet'].includes(this.$mq);
        },
        isTablet() {
            return ['tablet'].includes(this.$mq);
        },
        isDesktop() {
            return this.$mq === 'desktopSmall' || this.$mq === 'desktop';
        },
        isDesktopSmall() {
            return this.$mq === 'desktopSmall';
        },
    },
};
